import { Dropdown, InputRef, Menu, Typography } from "antd";
import { Form, Table, Modal, Spin, Progress } from "antd";
import type { FormInstance } from "antd/lib/form";
import { Button } from "primereact/button";
import { TieredMenu } from "primereact/tieredmenu";
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Col } from "react-bootstrap";
import { IoEllipsisVertical } from "react-icons/io5";
import { IMemoDetailModel } from "../../../IRequestModel/IMemoDetailModel";
import { GetRefDocFormTable } from "../../../Services/MemoService";
import {
  IColumn,
  SelectDataDialog,
} from "../../Select/SelectionDataDialog/SelectDataDialog";
import { AttachmentTableComponent } from "../AttachmentUploadControlComponent/AttachmentComponent";
import { DatePickerTableComponent } from "../DatePickerControlComponent/DatePickerControlComponent";
import { InputTableComponent } from "../InputControlComponent/InputControlComponent";
// import { NumberToBahtTableComponent } from "../NumberToBahtControlComponent/NumberToBahtControl";
import { InputNumberTableComponent } from "../InputNumberControlComponent/InputNumberControlComponent";
import { CheckboxTableComponent } from "../MainCheckboxControl/CheckboxComponent";
import { SelectCheckboxTableComponent } from "../MainCheckboxControl/SelectCheckboxComponent";
import { RadioTableComponent } from "../RadioControlComponent/RadioControlComponent";
import { SelectDropdownTableComponent } from "../SelectDropdownContronComponent/SelectDropdownContronComponent";
import { InputTextAreaTableComponent } from "../TextAreaControlComponent/InputTextAreaControlComponent";
import MoveToDialog from "./MoveToDialog";
import "./TableComponentCSS.css";
import { GetReportById } from "../../../Services/ReportService";
import TableFooter from "./TableFooter";

import moment from "moment";
import ComponentLabel from "../../ControlComponents/ComponentLabel";
import {
  CheckCircleOutlined,
  CloseSquareOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import ExcelTablePreview from "./ExcelTablePreview";
import { ILogicRequestBody, ILogicCondition, labelAction } from '../../../IRequestModel/ILogicModel';
import {
  checkIsCorrect,
  isConditionSatisfiedFunc,
} from "../../../Helper/LogicHelper";
import {
  balanceParentheses,
  calCulateInTableFunc,
  getDefValueInTemplate,
} from "../../../Helper/RequestScreenHelper";
import { LogicType } from "../../../constants/logic-type";
import { UseFormGetValues } from "react-hook-form";
import _ from "lodash";
import { generateQuickGuid } from "../../../Helper/GenerateGuid";
import { onDatareladToLoadData } from "../../../Services/TemplateService";
import useAlert from "../../../hooks/useAlert";
import { Control } from "react-hook-form";
import useMasterSetting from "../../../hooks/useMasterSetting";

const { confirm } = Modal;
const { Text } = Typography;

const EditableContext = React.createContext<FormInstance<any> | null>(null);

export interface tableSelectOption {
  actionsCol: {
    label: string;
    rowIdx: number;
    colIdx: number;
    value: any;
  };
  targetCol: {
    label: string;
    rowIdx: number;
    colIdx: number;
    options: { item: string }[];
  };
}

export interface Item {
  key: string;
  name: string;
  age: string;
  address: string;
}
interface EditableRowProps {
  index: number;
}

export type TableInputProps = {
  rowIdx?: number;
  colIdx?: number;
  template: any;
  name: string;
  saveFunc: any;
  inputRef: any;
  value?: any;
  isEditing?: boolean;
  onEdit: () => void;
  children: any;
  canEditDoc: any;
  checkActionPage: any;
  buttonType: string;
  record?: any;
  allLogicInTable?: ILogicRequestBody[];
  actionAlert?: any;
  toggleEdit?: any;
  getValues?: UseFormGetValues<{
    items: any;
  }>;
  layout?: any;
  check?: (value :boolean) => void;
  rowData?: any;
};

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: keyof Item;
  record: any;
  handleSave: (
    rowOrRows: Item | Item[],
    dataIndex?: string,
    responseControlChange?: any,
    colTemplate?: any
  ) => void;
  template: any;
  onControlChange: any;
  rowTemplate: any;
  colTemplate: any;
  canEditDoc: any;
  checkActionPage: any;
  buttonType: string;
  isError: boolean;
  allLogicInTable: ILogicRequestBody[];
  actionAlert?: any;
  setButtonType: (buttonType: any) => void;
  refDocOptions: any[];
  refTableColumn: any[];
  getValues: UseFormGetValues<{
    items: any;
  }>;
  layout: any;
  rowIndex: number;
  // isControlLoading: any;
  keytable:number
}

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  template,
  onControlChange,
  rowTemplate,
  colTemplate,
  canEditDoc,
  checkActionPage,
  buttonType,
  setButtonType,
  isError,
  allLogicInTable,
  refDocOptions,
  refTableColumn,
  actionAlert,
  getValues,
  layout,
  rowIndex,
  keytable,
  ...restProps
}) => {

  const [editing, setEditing] = useState<boolean>(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;
  const [memoByOption, setMemoByOption] = useState<number | any>(0);
  const [haveLink, setHaveLink] = useState<any>();

  const [isRevision, setIsRevision] = useState<boolean>(false);
  const [reportRef, setReportRef] = useState<number>(0);

  // const [templateState, setTemplateState] = useTemplateDescContext();
  useEffect(() => {
    if (editing) {
      setTimeout(() => {
        inputRef?.current!?.focus({
          cursor: "end",
        });
      }, 0);
    }
  }, [editing]);

  const toggleEdit = async (indices?: string[] | number , newRecord? :any) => {
    setEditing((prev) => !prev);

    if (Array.isArray(indices)) {
      const updates: any = {};
      indices.forEach((key) => {
        if(newRecord){
          updates[key] = newRecord[key];
        }else{
        updates[key] = record[key];
        }
      });
      form.setFieldsValue(updates);
    } else {
      form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    }
  };

  const save = async (
    value?: any,
    type?: any,
    check?: any
  ) => {
    try {
      const values = await form.getFieldsValue();
      const columns = template.attribute.column;
      const resetIndexes: number[] = check?.setReset || [];

      const resetData: Record<string, any> = {};
      const resetKeys: string[] = [];

      resetIndexes.forEach((idx) => {
        const col = columns[idx];
        const label = col?.control?.template?.label;

        if (!label) return;

        resetData[label] = getDefValueInTemplate(col.control.template);
        resetKeys.push(label);
      });
      // record[dataIndex] = value
     console.log("before merge", record["รับเป็นบาท"]);

      
     const cleanValues = Object.fromEntries(
      Object.entries(values || {}).filter(
        ([_, value]) => value !== "" && ( !check ||check?.label && (_=== check?.label))
      )
    );
    const cleanResetData = Object.fromEntries(
      Object.entries(resetData || {}).filter(
        ([_, value]) => value !== ""
      )
    );

      const mergedRecord = {
        ...record,
        ...cleanValues,
        ...cleanResetData,
      };

        if (type === "cb") {
          mergedRecord[dataIndex] = value;
        }

        console.log("testqqqqqfinal", mergedRecord["รับเป็นบาท"]);
      console.log(mergedRecord, dataIndex ,record,value ,check, columns,type, resetData ,"testqqss");
      
      handleSave(mergedRecord, dataIndex , false , columns.find((col:any) => col.label === dataIndex));
      toggleEdit(resetKeys, mergedRecord);

    } catch (errInfo) {
      if (process.env.NODE_ENV === "development") {
        console.error("Save failed:", errInfo);
      }
    }
  };

  useEffect(() => {
    if (record !== undefined) {
      findRefMemoId(record);
    }
  }, [memoByOption, refDocOptions]);

  const findRefMemoId = (record: any) => {
    const res = refDocOptions.find((e: any) => {
      const refdoc = template?.attribute?.mergecolumnrefdoc;

      Array.isArray(refdoc) && refdoc?.forEach((_refdoc: any) => {
        if (_refdoc !== undefined && _refdoc !== null) {
          if (_refdoc.HaveLink) {
            setHaveLink((prevState: any) => ({
              ...prevState, // Keep existing keys
              [_refdoc.ColumnLabel]: _refdoc, // Add or update the new key
            }));
          }
          if (_refdoc.IsRevision) {
            const _reportRef = template?.attribute?.refdoc?.docReport;
            setIsRevision(true);
            setReportRef(_reportRef);
          }
        }
      });
      return refdoc !== undefined;
    });

    if (res !== undefined && res !== null) {
      if (isRevision) {
        setMemoByOption(res);
      } else {
        setMemoByOption(res.Memo_MemoId);
      }
    } else {
      const refdoc = template?.attribute?.mergecolumnrefdoc;
      Array.isArray(refdoc) && refdoc?.forEach((_refdoc: any) => {
        if (_refdoc !== undefined && _refdoc !== null) {
          if (_refdoc.HaveLink) {
            setHaveLink((prevState: any) => ({
              ...prevState, // Keep existing keys
              [_refdoc.ColumnLabel]: _refdoc, // Add or update the new key
            }));
          }
          if (_refdoc.IsRevision) {
            const _reportRef = template?.attribute?.refdoc?.docReport;
            setIsRevision(true);
            setReportRef(_reportRef);
          }
        }
      });
    }
  };
  let childNode = dataIndex ? <></> : children;
  const logicsOfTable =
    allLogicInTable?.filter(
      (e) =>
        e.logictype === LogicType.ReadOnlyControl ||
        e.logictype === LogicType.HideControl ||
        e.logictype === LogicType.SetValueControl
    ) || [];

  if (editable) {
    for (let i = 0; i < template.attribute.column.length; i++) {
      let _col = template.attribute.column[i];
      const label = _col.control.template.label
        ? _col.control.template.label
        : _col.label;
      const type = _col.control.template.type;

      const logicInCol = logicsOfTable.filter((e) => e.Key === dataIndex);

      let isShowOnLogic = true;
      if (logicInCol.length > 0) {
        logicInCol?.forEach((logic) => {
          if (logic.logictype === LogicType.ReadOnlyControl) {
            let isConditionSatisfied = false;
            Object.keys(record).forEach((key) => {
              if (!isConditionSatisfied) {
                isConditionSatisfied = isConditionSatisfiedFunc(
                  key,
                  record[key],
                  logic?.jsonValue
                );
              }
            });
            if (logic.Key === _col.label) {
              _col.isReadOnly = isConditionSatisfied;

              // logic resetonaction
              if (logic?.jsonValue?.resetonaction) {
                const columns = template.attribute.column;

                // หา column ที่อยู่ในเงื่อนไข conditions
                const targetIndex = columns.findIndex((cols:any) =>
                  logic.jsonValue.conditions.some((group: any) =>
                    group.conditions.some((c: any) => c.field === cols.label),
                  ),
                );

                // หา column ที่ trigger
                const triggerIndex = columns.findIndex(
                  (col:any) => col.label === logic.Key,
                );

                if (targetIndex !== -1 && triggerIndex !== -1) {
                  const resetList = columns[targetIndex].setReset || [];

                  if (!resetList.includes(triggerIndex)) {
                    columns[targetIndex].setReset = [
                      ...resetList,
                      triggerIndex,
                    ];
                  }
                }
              }
            }
          } else if (logic.logictype === LogicType.HideControl) {
            let isConditionSatisfied = false;
            Object.keys(record).forEach((key) => {
              if (!isConditionSatisfied) {
                isConditionSatisfied = isConditionSatisfiedFunc(
                  key,
                  record[key],
                  logic?.jsonValue
                );
              }
            });
            
            isShowOnLogic = isShowOnLogic && !isConditionSatisfied; 

            if (logic.Key === _col.label) {
              // logic resetonaction
              if (logic?.jsonValue?.resetonaction) {
                const columns = template.attribute.column;

                // หา column ที่อยู่ในเงื่อนไข conditions
                const targetIndex = columns.findIndex((cols:any) =>
                  logic.jsonValue.conditions.some((group: any) =>
                    group.conditions.some((c: any) => c.field === cols.label),
                  ),
                );

                // หา column ที่ trigger
                const triggerIndex = columns.findIndex(
                  (col:any) => col.label === logic.Key,
                );

                if (targetIndex !== -1 && triggerIndex !== -1) {
                  const resetList = columns[targetIndex].setReset || [];

                  if (!resetList.includes(triggerIndex)) {
                    columns[targetIndex].setReset = [
                      ...resetList,
                      triggerIndex,
                    ];
                  }
                }
              }   
            }
          }
        });
      }

      if (isShowOnLogic) {
        if (label === dataIndex) {
          if (type === "ta") {
            childNode = (
              <InputTextAreaTableComponent
                {...{ checkActionPage, buttonType }}
                inputRef={inputRef}
                saveFunc={save}
                name={dataIndex}
                template={_col.control.template}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                rowIdx={Number(record.key)}
                colIdx={i}
                actionAlert={actionAlert}
                toggleEdit={toggleEdit}
              />
            );
          } else if (type === "dd") {
            childNode = (
              <SelectDropdownTableComponent
                {...{
                  checkActionPage,
                  buttonType,
                  record,
                  allLogicInTable,
                  getValues,
                }}
                inputRef={inputRef}
                saveFunc={() => save(undefined, undefined, _col)}
                name={dataIndex}
                template={_col.control.template}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                rowIdx={Number(record.key)}
                colIdx={i}
                actionAlert={actionAlert}
              />
            );
          } else if (type === "l") {
          } else if (type === "c") {
            childNode = (
              <InputNumberTableComponent
                {...{ checkActionPage, buttonType }}
                inputRef={inputRef}
                rowIdx={Number(record.key)}
                colIdx={i}
                saveFunc={() => save(undefined, undefined, _col)}
                name={dataIndex}
                template={_col.control.template}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                actionAlert={actionAlert}
                rowData={record}
              />
            );
          }
          // else if (type === "btt") {
          //   childNode = (
          //     <NumberToBahtTableComponent
          //       inputRef={inputRef}
          //       saveFunc={save}
          //       {...{ checkActionPage, buttonType }}
          //       rowIdx={Number(record.key)}
          //       colIdx={i}
          //       name={dataIndex}
          //       template={_col.control.template}
          //       canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
          //       isEditing={editing}
          //       onEdit={toggleEdit}
          //       children={children}
          //       actionAlert={actionAlert}
          //     />
          //   )
          // }
          else if (type === "cb") {
            if (_col.control.template.attribute.display === "dd") {
              childNode = (
                <SelectCheckboxTableComponent
                  {...{ checkActionPage, buttonType, record, allLogicInTable }}
                  inputRef={inputRef}
                  saveFunc={() => save(undefined, undefined, _col)}
                  name={dataIndex}
                  template={_col.control.template}
                  canEditDoc={
                    !_col.isReadOnly && (_col.isEditable || canEditDoc)
                  }
                  isEditing={editing}
                  onEdit={toggleEdit}
                  children={children}
                  actionAlert={actionAlert}
                />
              );
            } else {
              childNode = (<>
                <CheckboxTableComponent
                  {...{ checkActionPage, buttonType }}
                  inputRef={inputRef}
                  key={record && record[dataIndex] ? record[dataIndex]+keytable: keytable}
                  value={record[dataIndex]}
                  // key={_col.control.template}
                  saveFunc={(val:any ,type:any ) => {
                    console.log(val ,type );
                    
                    save(val ,type, _col)}}
                  name={dataIndex}
                  template={_col.control.template}
                  canEditDoc={
                    !_col.isReadOnly && (_col.isEditable || canEditDoc)
                  }
                  isEditing={editing}
                  onEdit={toggleEdit}
                  children={children}
                  actionAlert={actionAlert}
                /></>
              );
            }
          } else if (type === "t") {
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host;
            childNode =
              haveLink &&
                haveLink[label]?.HaveLink === true &&
                haveLink[label]?.ColumnLabel === label ? (
                haveLink[label]?.IsRevision ? (
                  <a
                    href={`${new URL(
                      `${baseUrl}/Request?AutoNumber=${record[dataIndex]}&RefDocLabel=${haveLink[label].RefDocLabel}&ReportRef=${reportRef}`
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {record[dataIndex]}
                  </a>
                ) : (
                  <a
                    href={`${baseUrl}/Request?MemoID=${refDocOptions.find(
                      (doc) =>
                        doc[haveLink[label].RefDocLabel] === record[dataIndex] &&
                        doc?.Memo_MemoId === record?.memoRef?.Memo_MemoId
                    )?.Memo_MemoId ? refDocOptions.find(
                      (doc) =>
                        doc[haveLink[label].RefDocLabel] === record[dataIndex] &&
                        doc?.Memo_MemoId === record?.memoRef?.Memo_MemoId
                    )?.Memo_MemoId : record['memoRef']?.Memo_MemoId
                      } `}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {record[dataIndex]}
                  </a>
                )
              ) : (
                <>
                  <InputTableComponent
                    {...{ checkActionPage, buttonType }}
                    inputRef={inputRef}
                    saveFunc={() => save(undefined, undefined, _col)}
                    name={dataIndex}
                    template={_col.control.template}
                    canEditDoc={
                      !_col.isReadOnly && (_col.isEditable || canEditDoc)
                    }
                    isEditing={editing}
                    onEdit={toggleEdit}
                    children={children}
                    actionAlert={actionAlert}
                    rowIdx={rowIndex}
                    colIdx={i}
                    toggleEdit={toggleEdit}
                  />
                </>
              );
            // }
          } else if (type === "r") {
            childNode = (
              <RadioTableComponent
                {...{ checkActionPage, buttonType }}
                inputRef={inputRef}
                saveFunc={() => save(undefined, undefined, _col)}
                name={dataIndex}
                value={record[dataIndex]}
                template={_col.control.template}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                actionAlert={actionAlert}
              />
            );
          } else if (type === "d") {
            childNode = (
              <DatePickerTableComponent
                {...{ checkActionPage, buttonType }}
                inputRef={inputRef}
                saveFunc={save}
                name={dataIndex}
                template={_col.control.template}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                actionAlert={actionAlert}
              />
            );
          } else if (type === "at") {
            childNode = (
              <>
              <AttachmentTableComponent
                {...{ checkActionPage, buttonType }}
                inputRef={inputRef}
                saveFunc={save}
                name={dataIndex}
                canEditDoc={!_col.isReadOnly && (_col.isEditable || canEditDoc)}
                template={_col.control.template}
                value={record[dataIndex]}
                isEditing={editing}
                onEdit={toggleEdit}
                children={children}
                record={record}
                rowIdx={Number(record.key)}
                colIdx={i}
                actionAlert={actionAlert}
              /></>
            );
          } else if (type === "bt") {
          } else if (type === "id") {
            return <>1</>;
          } else if (type === "action") {
            // return <InputText value={"1"} />;
          }
        }
      }
    }
  }

  return (
    <td
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
      {...restProps}
    >
      <div>{childNode}</div>
    </td>
  );
};

type EditableTableProps = Parameters<typeof Table>[0];

type ColumnTypes = Exclude<EditableTableProps["columns"], undefined>;
type TableProps = {
  _columns: any;
  _data: any;
  onChange: any;
  layout: any;
  isControlLoading: any;
  onControlChange: any;
  rowTemplate: any;
  colTemplate: any;
  canEditDoc: any;
  checkActionPage: any;
  buttonType: string;
  tableSummary?: any;
  onCheckInterface: any;
  onSubmit: any;
  isError: boolean;
  memoDetail: IMemoDetailModel;
  updateTableSummaries: (tableTemp: any, value: any) => void;
  checkInterFace: any;
  interfaceButton: any;
  allLogicInTable: ILogicRequestBody[];
  actionAlert?: any;
  setButtonType: (data: any) => void;
  colText?: number;
  rowIdx: number;
  colIdx: number;
  getValues: UseFormGetValues<{
    items: any;
  }>;
  control: Control<{ item: any }, object>;
  handleSave?: (rowOrRows: any | any[], dataIndex?: string) => void;
};

const TableComponent: React.FC<TableProps> = ({
  _columns,
  _data,
  onChange,
  layout,
  isControlLoading,
  onControlChange,
  rowTemplate,
  colTemplate,
  canEditDoc,
  checkActionPage,
  buttonType,
  tableSummary,
  onCheckInterface,
  onSubmit,
  getValues,
  isError,
  memoDetail,
  allLogicInTable,
  updateTableSummaries,
  checkInterFace,
  interfaceButton,
  actionAlert,
  setButtonType,
  colIdx,
  rowIdx,
  colText,
  ...props
}) => {
  // State สำหรับเก็บ row ที่เหลือหลัง filter (currentDataSource)
  const [filteredRows, setFilteredRows] = useState<any[] | null>(null);
  const [currentDataSource, setCurrentDataSource] = useState<any[] | null>(null);
  const [moveToDialogVisible, setMoveToDialogVisible] =
    useState<boolean>(false);
  const [moveFormIndex, setMoveFormIndex] = useState<number>(-1);
  const { masterSetting } = useMasterSetting();
  const tableGenerateNewGuid = masterSetting?.duplicateRowSameId;
  const templateCode = memoDetail?.template_code;
  const [summary, setSummary] = useState<any>();
  const [tableLoad, setTableLoad] = useState<boolean>(false);
  const [spinloading, setSpinloading] = useState<boolean>(false);
  const [refTableDialogVisible, setRefTableDialogVisible] =
    useState<boolean>(false);
  const [refTableLoading, setRefTableLoading] = useState<boolean>(false);
  const [refDocOptions, setRefDocOptions] = useState<any[]>([]);
  const [refTableColumn, setRefTableColumn] = useState<IColumn[]>([]);
  const [tableFooter, setTableFooter] = useState<any>(
    layout.template.attribute?.footerTable?.rows || []
  );
  const [exportFile, setExportFile] = useState<any[]>([]);
  const [loadFile, setLoadFile] = useState<boolean>(false);
  const { toggleAlert } = useAlert();

  const [percent, setPercent] = useState<number>(0);

  useEffect(() => {
    // เปอร์เซ็นต์โหลดในตาราง
    let timer: any;
    if (tableLoad) {
      setPercent(0);
      timer = setInterval(() => {
        setPercent((prev) => {
          if (prev >= 95) {
            clearInterval(timer);
            return 95;
          }
          
          const increment = prev < 50 ? 5 : prev < 80 ? 2 : 1;
          return prev + increment;
        });
      });
    } else {
      setPercent(100);
    }

    return () => clearInterval(timer);
  }, [tableLoad]);


  const colIndexes: { [key: string]: number } = useMemo(() => {
    let obj: { [key: string]: number } = {};
    _columns.forEach((e: { dataIndex: any }, idx: any) => {
      obj[e.dataIndex || "#"] = idx;
      
    });
    return obj;
  }, []);
  useEffect(() => {
    if (
      layout.template.attribute.enabledpopupdefdoc !== "Y" &&
      refDocOptions.length === 0 &&
      !spinloading
    ) {
      return setSpinloading(true);
    }

    // fetchRefDocFormTable();
    setSpinloading(true)
  }, []);

  useEffect(() => {
    setSummary(tableSummary);
  }, [tableSummary]);

  const handleDelete = (key: React.Key) => {
    const newData = _data.filter((item: any) => item.key !== key);
    if (newData.length === 0) {
      summaryFunc();
    }
    // onChange({ row: [...returnToValue(newData)] });
    onChange({ ...layout, data: { row: returnToValue(newData) } }, 0);

    setTimeout(() => {
      setTableLoad(false);
    }, 500);
  };

  const menu = useRef<any[]>([]);

  async function createRowCopy(key: number) {
    let newData: any = {
      key: key,
    };
    const cols = layout.template.attribute.column;

    const tableLogic = allLogicInTable.filter((e) => {
      if (e.logictype === LogicType.SetValueControl) {
        return e.actionlabel.split("|")[1] === layout.template.label;
      } else if (e.logictype === LogicType.DataSourceRelated) {
        return layout.template.attribute.column.some(
          (col: { label: string }) => col.label === e.Key
        );
      } else {
        return e.Key === layout.template.label;
      }
    });

    cols.map((col: any) => {
      let type = col.control.template.type;

      if (type == "cb") {
        newData[col.label] = col.control.template.attribute.items
          .filter((e: any) => e.check === "Y")
          .map((e: any) => e.item)
          .join(",");
      } else if (type == "t" || type == "ta" || type == "c") {
        if (col.label === "id") {
          newData[col.label] = generateQuickGuid();
        } else {
          newData[col.label] = col?.control?.template?.attribute?.default
            ? col.control.template.attribute.default
            : null;

          if (newData[col.label]) {
            newData[col.label] = newData[col.label].replace(
              /\[.+\]/gi,
              (x: any) => {
                let fmt = x.replace("[", "").replace("]", "");
                return moment().format(fmt);
              }
            );
          }
        }
      } else if (type == "dd" || type === "r") {
        newData[col.label] = col.control.template.attribute.items
          .filter((e: any) => e.checked === "Y")
          .map((e: any) => e.item)
          .join(",");
      } else if (type === "d") {
        if (col.control.template.attribute.default != "") {
          if (col.control.template.attribute.defaultType === "Days") {
            let defaultDate = parseInt(col.control.template.attribute.default);
            let defValue = "";

            if (defaultDate > 0) {
              defValue = moment()
                .add(defaultDate, "days")
                .format("DD MMM YYYY");
            } else {
              defValue = moment()
                .subtract(defaultDate * -1, "days")
                .format("DD MMM YYYY");
            }

            newData[col.label] = defValue;
          }
        }
      } else {
        newData[col.label] = null;
      }
    });

    for (const logic of tableLogic) {
      if (logic?.logictype === LogicType.SetValueControl) {
        let keyData = null;
        const tempDesc = getValues();

        for (const items of tempDesc.items) {
          for (const layout of items.layout) {
            if (layout.template.label === logic.Key) {
              keyData = layout;
              if (
                checkIsCorrect(logic.Value, logic.operator, layout.data.value)
              ) {
                newData[logic.actionlabel.split("|")[0]] = logic?.valuetoset ? logic?.valuetoset : layout?.data?.value;
              }
            }
          }
        }

        if (!keyData) {
          for (const key of Object.keys(newData)) {
            if (logic.Key === key) {
              if (checkIsCorrect(logic.Value, logic.operator, newData[key])) {
                newData[logic.actionlabel.split("|")[0]] = logic.valuetoset;
              }
            }
          }
        }
      } else if (logic?.logictype === LogicType.RefInfomation) {
        newData[logic.actionlabel] = logic.Value;
        newData["dataIndex"] = logic.actionlabel;
        const res = await onControlChange(
          layout.template,
          { ...newData, rowTemplate, colTemplate },
          newData,
          true
        );
        if (res) newData = res.value;
      }
    }

    return newData;
  }

  const handleAdd = async () => {
    let newData: any = await createRowCopy(_data.length);

    let eiei = [..._data, newData];

    setButtonType("addrow");

    onChange({ ...layout, data: { row: returnToValue(eiei) } }, 0);
  };

  const handleAddMultiRow = (newRows: any[]) => {
    let newData: any = newRows;
    let rows: any[] = [..._data];
    newData.map((e: any) => {
      rows.push(e);
    });
    rows.map((e: any, idx: number) => {
      e.key = idx;
    });

    onChange({ ...layout, data: { row: returnToValue(rows) } }, 0);
  };

  const returnToValue = (inputData: any) => {
    const formattedRows: any[] = [];
    const columns = layout.template.attribute.column;

    inputData?.forEach((rowData: any) => {
      let Keep: { value: string, memoRef: any ,isMerge ?:boolean }[] = [];

      const formattedRow = columns?.forEach((column: any) => {
        const rawValue = rowData[column.label];

        let numericValue = Number(rawValue?.toString().replace(/,/g, ""));
        if (rowData[column.label] === "")
          return Keep.push({ value: rawValue ?? null, memoRef: rowData['memoRef'] ,isMerge : typeof rowData['isMerge']=== "boolean" ? rowData['isMerge'] : false });

        if (isNaN(numericValue) && column?.control.template?.type === "c") {
          numericValue = rawValue;
          return Keep.push({ value: numericValue?.toString() ?? null, memoRef: rowData['memoRef'] ,isMerge : typeof rowData['isMerge']=== "boolean" ? rowData['isMerge'] : false });
        }
        Keep.push({ value: rawValue ?? null, memoRef: rowData['memoRef'] , isMerge : typeof rowData['isMerge']=== "boolean" ? rowData['isMerge'] : false });
      });
      formattedRows.push(Keep);
    });

    return formattedRows;
  };

  const calCulateFunc = (row: any) => {
    try {
      if (layout.template.formula !== "") {
        const formulas = layout.template.formula.split("|");
        const columns = layout.template.attribute.column;

        formulas.map((formula: string) => {
          let resulstField = formula.split("=");
          let formu: string = resulstField[0];
          let resultColIdx = -1;
          let resultDecimal = 0;
          let result: number = 0;

          if (formu.startsWith("Min") || formu.startsWith("Max")) {
            const operator = formu.startsWith("Max") ? "Max" : "Min";
            const fields = formu
              .substring(formu.indexOf("(") + 1, formu.lastIndexOf(")"))
              .split(",");

            fields?.forEach((field) => {
              columns?.forEach((col: any, colIdx: number) => {
                if (field === col.label) {
                  const value = Number(
                    row[col.label]?.toString()?.replaceAll(",", "")
                  );

                  if (!Number.isNaN(value))
                    if (
                      result === 0 ||
                      (operator === "Max" && value > result) ||
                      (operator === "Min" && value < result)
                    ) {
                      result = value;
                    }
                }
                if (col.label === resulstField[1]) {
                  resultColIdx = colIdx;
                  resultDecimal = Number(
                    col.control.template.attribute.decimal
                  );
                }
              });
            });
          } else if (formu.startsWith("diffdate")) {
            const fields = formu
              .substring(formu.indexOf("(") + 1, formu.lastIndexOf(")"))
              .split(",");

            let firstDate = moment(row[fields[0]]);
            let lastDate = moment(row[fields[1]]);
            let res = firstDate.diff(lastDate, "days");
            formu.replace(`diffdate(${firstDate}, ${lastDate})`, res.toString())
            const updatedFormula = formu.replace(`diffdate(${firstDate}, ${lastDate})`, res?.toString())
            var regExp = /[a-zA-Zก-๏]/g;
            if (!regExp.test(updatedFormula)) {
              res = eval(updatedFormula);
            }
            // if (res >= 0) {
            //   res += 1;
            // }

            result = res;
            const resCol = columns.find(
              (col: any) => col.label === resulstField[1]
            );
            resultDecimal = Number(resCol.control.template.attribute.decimal);
          } else if (formu.startsWith("diffmonth")) {
            const fields = formu
              .substring(formu.indexOf("(") + 1, formu.lastIndexOf(")"))
              .split(",");

            let firstMonth = moment(row[fields[0]]);
            let lastMonth = moment(row[fields[1]]);
            let res = firstMonth.diff(lastMonth, "months");
            formu.replace(`diffmonth(${firstMonth}, ${lastMonth})`, res.toString())
            const updatedFormula = formu.replace(`diffmonth(${firstMonth}, ${lastMonth})`, res?.toString())
            var regExp = /[a-zA-Zก-๏]/g;
            if (!regExp.test(updatedFormula)) {
              res = eval(updatedFormula);
            }
            // if (res >= 0) {
            //   res += 1;
            // }

            result = res;
            const resCol = columns.find(
              (col: any) => col.label === resulstField[1]
            );
            resultDecimal = Number(resCol.control.template.attribute.decimal);
          } else if (formu.startsWith("difftime")) {
            const fields = formu
              .substring(formu.indexOf("(") + 1, formu.lastIndexOf(")"))
              .split(",");

            let firstDate = moment(row[fields[0]], "h.mm");
            let lastDate = moment(row[fields[1]], "h.mm");
            let res = firstDate.diff(lastDate, "minutes");

            const hours = Math.trunc(res / 60);
            const remainingMinutes = res % 60;
            let formattedTime =
              res <= -1 && res >= -9
                ? `- 0.0${Math.abs(remainingMinutes)} `
                : hours === -0 && res < -10
                ? `- ${hours}.${Math.abs(remainingMinutes)} `
                : res < -10
                ? `${hours}.${Math.abs(remainingMinutes)} `
                : `${hours}.${remainingMinutes} `;

            result = Number(formattedTime);
            const resCol = columns.find(
              (col: any) => col.label === resulstField[1]
            );
            resultDecimal = Number(resCol.control.template.attribute.decimal);
          } else {
            let allField: any = resulstField[0].match(/[^+%\-\*\/=]+/g) || [];

            allField = allField.map((e: string) => {
              const newField = balanceParentheses(e);

              return newField;
            });

            allField?.forEach((field: string) => {
              if (field.startsWith("get")) {
                const labels = field
                  .substring(field.indexOf("(") + 1, field.lastIndexOf(")"))
                  .split(",");
                if (labels.length > 0) {
                  const items = getValues()?.items;
                  for (let index = 0; index < items.length; index++) {
                    const item = items[index];
                    for (let j = 0; j < item.layout.length; j++) {
                      const layout = item.layout[j];
                      if (layout.template.label) {
                        if (labels.includes(layout.template.label)) {
                          formu = formu.replace(
                            `get(${layout.template.label})`,
                            layout.data.value !== "NaN"
                              ? layout.data.value
                              : Number(0).toFixed(
                                  layout.template.attribute.decimal
                                )
                          );
                        }
                      }
                    }
                  }
                }
              } else {
                columns?.forEach((col: any, colIdx: number) => {
                  if (field === col.label) {
                    // แปลงตัวอักษรพิเศษ
                    const escapeReg = (val: string) => {
                      return val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    };
                    const safeValue = escapeReg(col.label);

                    // ใช้ regex แทนชื่อ col.label กรณีชื่อเหมือนกัน
                    // const regex_label = new RegExp(`\\b${col.label}\\b`, "g");
                    const regex_label = new RegExp(
                      `(?<![0-9A-Za-zก-๙๐-๙_])${safeValue}(?![0-9A-Za-zก-๙๐-๙_])`,
                      "g"
                    );

                    const decimal = Number(
                      col.control?.template?.attribute?.decimal ?? 0
                    );

                    const rowValue = row[col.label];
                    const numValue = Number(
                      rowValue?.toString()?.replaceAll(",", "")
                    );

                    // แปลงเป็น number และ เช็ค Value ว่า NaN ไหม
                    const formatValue = isNaN(numValue)
                      ? Number(0).toFixed(decimal)
                      : numValue.toFixed(decimal);

                    formu = formu.replace(regex_label, formatValue);
                    
                  }
                  if (col.label === resulstField[1]) {
                    resultColIdx = colIdx;
                    resultDecimal = Number(
                      col.control?.template?.attribute?.decimal ?? 0
                    );
                  }
                });
              }
            });

            let dd = formu.replaceAll(",", "");
            result = eval(dd);
          }

          row[resulstField[1]] = result
            ?.toLocaleString("en-UK", {
              minimumFractionDigits: resultDecimal,
              maximumFractionDigits: resultDecimal,
            })
            .replace(/,/g, "");
        });
      }
    } catch (error) {
      console.error("table=>cal=>error", error);
    }
  };

  const summaryFunc = () => {
    try {
      if (tableSummary) {
        const cols = layout.template.attribute.column;
        const _tableSummary = JSON.stringify(tableSummary);
        let _sum = JSON.parse(_tableSummary);

        cols.map((e: any) => {
          if (e.control.template.type === "c") {
            _sum[e.label] = 0;
            // const defaultValue = e.control.template.attribute?.default;
            // if (defaultValue !== undefined && defaultValue !== null && defaultValue !== "") {
            //   _sum[e.label] = Number(defaultValue);
            // } else {
            //   _sum[e.label] = 0;
            // }
          }
        });

        _data?.forEach((e: any) => {
          cols.map((col: any) => {
            if (col.control.template.type === "c") {
              //ทำไว้เผื่อแก้โครงสร้าง object ที่ผิดรูป
              if (!e[col.control.template.label]) {
                col.control.template.label = col.label;
              }

              if (e[col.control.template.label]) {
                if (e[col.control.template.label]) {
                  col.control.template.label = col.label;
                  if (
                    !Number.isNaN(
                      Number(
                        e[col.control.template.label]
                          ?.toString()
                          ?.replaceAll(",", "")
                      )
                    )
                  ) {
                    _sum[col.control.template.label] += Number(
                      e[col.control.template.label]
                        ?.toString()
                        ?.replaceAll(",", "")
                    );
                  } else if (
                    !Number.isNaN(Number(e[col.control.template.label]))
                  ) {
                    _sum[col.control.template.label] += Number(
                      e[col.control.template.label]
                    );
                  }
                }
              }
            }
          });
        });
        const debouncedCalCulateTableFooter = _.debounce(
          calCulateTableFooter,
          50
        );

        const debouncedUpdateTableSummaries = _.debounce(
          updateTableSummaries,
          50
        );

        if (!_.isEqual(tableSummary, _sum)) {
          calCulateTableFooter();
          updateTableSummaries(layout.template, _sum);
        } else {
          debouncedCalCulateTableFooter();
          // debouncedUpdateTableSummaries(layout.template, _sum);
        }
      }
    } catch (error) {
      console.error("table=>sum=>error", error);
    }
  };

  // รอ 300ms หลังข้อมูลหยุดเปลี่ยน แล้วคำนวณครั้งเดียว
  const summaryTimerRef = useRef<any>(null);

  useEffect(() => {
    if (summaryTimerRef.current) clearTimeout(summaryTimerRef.current);
    summaryTimerRef.current = setTimeout(() => {
      summaryFunc(); // คำนวณครั้งเดียวหลังหยุดพิมพ์
    }, 300);

    return () => {
      if (summaryTimerRef.current) clearTimeout(summaryTimerRef.current);
    };
  }, [_data]);

  const handleSave = async (
    rowOrRows: any,
    dataIndex?: string,
    skipLogic?: boolean,
    colTemplate?: any
  ) => {
    const newData = [..._data];
    let res = layout;
    let lastRowKey = 0;
    const rows = Array.isArray(rowOrRows) ? rowOrRows : [rowOrRows];
    const isBulk = Array.isArray(rowOrRows);
    if (isBulk) setTableLoad(true);

    try {
      const CHUNK_SIZE = 5;

      for (let i = 0; i < rows.length; i += CHUNK_SIZE) {
        const chunk = rows.slice(i, i + CHUNK_SIZE);

        for (const rowData of chunk) {
          let row = { ...rowData };
          const index = newData.findIndex((item) => item.key === row.key);
          if (index === -1) continue;

          if (isBulk && dataIndex && newData[index][dataIndex] === row[dataIndex]) {
            newData.splice(index, 1, { ...newData[index], ...row });
            continue;
          }

          if (row["rowstate"] !== undefined && row["rowstate"] !== "i" && dataIndex) {
            const originTemplatedesc: any = getValues();
            const rowDataOrigin =
              originTemplatedesc.items[rowTemplate].layout[colTemplate].data.row[row.key];
            const actionIndex =
              originTemplatedesc.items[rowTemplate].layout[colTemplate]
                .template.attribute.column.findIndex(
                  (col: { label: any }) => col.label === dataIndex
                );
            row["rowstate"] =
              rowDataOrigin[actionIndex]?.value !== row[dataIndex] ? "u" : null;
          }

          calCulateFunc(row);

          // skipLogic = true ข้าม onControlChange
          if (!skipLogic) {
            let responseControlChange = await onControlChange(
              layout.template,
              { ...row, rowTemplate, colTemplate, dataIndex },
              row,
              true,
              undefined,
              undefined,
              colTemplate,
              rowOrRows
            );
  

            if (responseControlChange?.type === "table") {
              const mergedValue = responseControlChange.value;
              const cbColumns = layout.template.attribute.column
                .filter((col: any) => col.control.template.type === "cb")
                .map((col: any) => col.label);

              Object.keys(mergedValue).forEach((key) => {
                if (cbColumns.includes(key) && !!row[key] && row[key] !== "") return;
                if (mergedValue[key] !== null && mergedValue[key] !== undefined) {
                  row[key] = mergedValue[key];
                }
              });
              calCulateFunc(row);
            }

            if (responseControlChange?.type === "control") {
              for (const items of responseControlChange.value) {
                for (const _layout of items.layout) {
                  if (_layout.template.label === layout.template.label) {
                    res = _layout;
                  }
                }
              }
            }
          }

          newData.splice(index, 1, { ...newData[index], ...row });
          lastRowKey = row.key;
        }

        await new Promise((resolve) => setTimeout(resolve, 0));
      }

      onChange(
        { ...res, data: { row: returnToValue(newData) } },
        lastRowKey,
        dataIndex ? colIndexes[dataIndex] : undefined
      );

      // run logic ครั้งเดียวหลัง save เสร็จ
      if (skipLogic && isBulk) {
        // const colDef = layout.template.attribute.column.find(
        //   (col: any) => col.label === dataIndex
        // );
        // const isCbCol = colDef?.control?.template?.type === "cb";

        const firstChangedRow = newData.find((r: any) =>
          rows.some((orig: any) => orig.key === r.key)
        );
        if (true) {
          await onControlChange(
            layout.template,
            { ...firstChangedRow, rowTemplate, colTemplate, dataIndex },
            firstChangedRow,
            true,
            undefined,
            undefined,
            colTemplate,
            rowOrRows
          );
        }
      }

    } catch (error) {
      console.error(error);
    } finally {
      if (isBulk) setTimeout(() => setTableLoad(false), 1000); // ตั้งเวลาดีเลย์
    }
  };

  const processLogicInTable = async (
    tableLogic: any[],
    row: any,
    errorList?: any[]
  ) => {
    if (tableLogic.length === 0) return row;
    row["logicError"] = [];

    const groupedTableLogic = tableLogic.reduce((acc: any, item: any) => {
      const key = item.Key; // Replace 'key' with the actual key you want to group by
      if (!row[key]) return acc;
      if (row[key].trim() === "") return acc;
      if (!acc[key]) {
        acc[key] = { relatedvalue: item.relatedvalue };
        acc[key]["conditions"] = [];
      }
      item["Value"] = row[key];
      acc[key]["conditions"].push(item);
      return acc;
    }, {});

    for (let i = 0; i < Object.keys(groupedTableLogic).length; i++) {
      try {
        const key: any = Object.keys(groupedTableLogic)[i];

        const targetLogic = groupedTableLogic[key];
        const res = await onDatareladToLoadData(targetLogic?.conditions);

        if (res && res?.length > 0) {
          const someRes = targetLogic.relatedvalue.some(
            (relatedJson: { label: string | number; value: string | number }) =>
              res[0][relatedJson.value].trim() !== ""
          );
          targetLogic.relatedvalue.forEach(
            (relatedJson: {
              label: string | number;
              value: string | number;
            }) => {
              row[relatedJson.label] = res[0][relatedJson.value];
            }
          );
          if (!someRes) {
            row["logicError"].push(targetLogic?.conditions);
            errorList?.push(row);
          }
        } else {
          row["logicError"].push(targetLogic?.conditions);
          targetLogic.relatedvalue.forEach(
            (relatedJson: {
              label: string | number;
              value: string | number;
            }) => {
              row[relatedJson.label] = null;
            }
          );
          errorList?.push(row);
        }
      } catch (error) {
        console.error("table=>error", error, row);
      }
    }

    return row;
  };
  const [ keytable ,setKeyTable ] = useState<number>(0);
  
  const defColumns: any[] = _columns.map((_col: any ,index :number) => {
    if (_col.dataIndex && 
      layout.template.attribute.column[index-1]?.control.template.type ==="cb" &&
      layout.template.attribute.column[index-1]?.control.template.attribute?.items.length ===1
    ) {

      const filterOptions = useMemo(() => {
        
        const source = _data.filter((row: any) => {if(!filteredRows)return true;
                return Array.isArray(filteredRows) && filteredRows.some((f: any) => f.key === row.key)
              }); 
        return source
          .map((item: any) => item[_col.dataIndex])
          .filter((value: any, index: number, self: any[]) => self.indexOf(value) === index)
          .map((value: any) => ({ text: value, value: value }));
      }, [filteredRows, _data, _col.dataIndex]);

      return {
        ..._col,
        title: (
          <div style={{ display: "flex", alignItems: "center" }}>
        
        <div style={{ marginLeft: 8, display: "flex", alignItems: "center"}}>
          <input
            className="custom-checkbox"
            type="checkbox"
            style={{
              marginRight: 4,
              width: 16,
              height: 16,
              borderRadius: 3,
              cursor: "pointer",
            }}
            title="select all"
            checked={
              Array.isArray(_data) && _data.length > 0 &&
              _data.filter((row: any) => {if(!filteredRows)return true;
                return Array.isArray(filteredRows) && filteredRows.some((f: any) => f.key === row.key)
              }).every(row => !!row[_col.dataIndex] && row[_col.dataIndex] !== "")
            }
            //add style pointer when hover
            onClick={async (e) => {
              e.stopPropagation();
              const checked = e.currentTarget.checked;
              const initCheckBoxValue =
                layout.template.attribute.column.find(
                  (col: any) => col.label === _col.dataIndex
                )?.control?.template?.attribute?.items?.[0]?.item || "";

              const activeRows = Array.isArray(filteredRows) ? filteredRows : _data;
              const activeKeys = new Set(activeRows.map((r: any) => r.key));

              const newData = _data.map((item: any) => {
                if (!activeKeys.has(item.key)) return item;
                return {
                  ...item,
                  [_col.dataIndex]: checked ? initCheckBoxValue : "",
                };
              });

              // skipLogic = true 
              await handleSave(newData, _col.dataIndex, true , _col);
              setKeyTable((prev) => prev + 1);
            }}
          />
        </div>
        {_col.title}
          </div>
        ),
        
        filters: (filterOptions),
        filterSearch: true,
        // sorter: (a: any, b: any) => {
        //   if (a[_col.dataIndex] === undefined) return -1;
        //   if (b[_col.dataIndex] === undefined) return 1;
        //   if (a[_col.dataIndex] === b[_col.dataIndex]) return 0;
        //   return a[_col.dataIndex] > b[_col.dataIndex] ? 1 : -1;
        // },
        onFilter: (value: any, record: any) => record[_col.dataIndex] === value,
      }
    }
    if (_col.dataIndex && layout.template.filterintable  === "Y") {
      const filterOptions = useMemo(() => {
        const source = (currentDataSource??_data).filter((row: any) => {if(!filteredRows)return true;
                return Array.isArray(filteredRows) && filteredRows.some((f: any) => f.key === row.key)
              });
        return source
          .map((item: any) => item[_col.dataIndex])
          .filter((value: any, index: number, self: any[]) => self.indexOf(value) === index)
          .map((value: any) => ({ text: value, value: value }));
      }, [filteredRows, _data, _col.dataIndex, currentDataSource]);
      return {
        ..._col,
        filters: filterOptions,
        onFilter: (value: any, record: any) => record[_col.dataIndex] === value,
        filterSearch: true,
        sorter: (a: any, b: any) => {
          if (a[_col.dataIndex] === undefined) return -1;
          if (b[_col.dataIndex] === undefined) return 1;
          if (a[_col.dataIndex] === b[_col.dataIndex]) return 0;
          if(layout.template.attribute.column[index-1]?.control.template.type === "c"){
          const aNumber = Number(
            a[_col.dataIndex]?.toString()?.replaceAll(",", "")
          );
          const bNumber = Number(
            b[_col.dataIndex]?.toString()?.replaceAll(",", "")
          );

          return (aNumber === Infinity ? 0 : aNumber) -
                (bNumber === Infinity ? 0 : bNumber);
          }
          if(layout.template.attribute.column[index-1]?.control.template.type === "d"){
            return moment(a[_col.dataIndex]).isAfter(moment(b[_col.dataIndex])) ? 1 : -1;
          }
          return a[_col.dataIndex] > b[_col.dataIndex] ? 1 : -1;
        }

      }
    }
    return {
      ..._col,
    };
  });

  if (canEditDoc && layout.template.disAllowAction !== true) {
    defColumns.push({
      title: (
        <i
          className="pi pi-plus"
          id="add_bt"
          onClick={() => {
            try {
              if (!!layout.template.disAllowAction?.add) return
              if (layout.template.attribute.enabledpopupdefdoc === "Y") {
                fetchRefDocFormTable();
                setRefTableDialogVisible(true);
              } else {
                handleAdd();
              }
            } catch (error) {
              console.error("table=>error", error);
            }
          }}

        ></i>
      ),
      className: layout.template.disAllowAction?.add ? "action-column-notallow-add" : "action-column",
      key: "operation",
      align: "center",
      fixed: "right",
      width: 50,
      render: (_: any, record: { key: number }) => (
        <div >{actionBodyTemplate(record.key)}</div>
      ),

      onCell: (record: any) => {
        return {
          onClick: (e: any) => {
            menu?.current[record?.key]?.toggle(e);
          },
        };
      },
    });
  }

  const addRowTo = (key: number) => {
    try {
      let rows: any[] = _data;
      let newData: any = createRowCopy(key);
      if (newData["rowstate"] !== undefined) {
        newData["rowstate"] = "i";
      }
      rows.splice(key, 0, newData);
      rows.map((row: any, idx: number) => (row.key = idx));
      onChange({ ...layout, data: { row: returnToValue(rows) } }, 0);

      setTimeout(() => {
        setTableLoad(false);
      }, 500);
    } catch (error) {
      console.error("table=>error", error);
    }
  };

  const duplicate = (key: number) => {
    try {
      let rows: any[] = _data;
      let newData: any = createRowCopy(key);
      const matchedTableName = layout.template.label;

      layout.template?.attribute?.column?.forEach((_col: any) => {
        if (_col.label === "rowstate") {
          newData[_col.label] = "i";
        } else {

          newData[_col.label] = rows[key][_col.label];
        }
      });
      rows.splice(key + 1, 0, newData);

      const splitTemplateCode = tableGenerateNewGuid?.Value1?.split("|")?.map((s: string) => s.trim()) || [];
      const splitTable = tableGenerateNewGuid?.Value2?.split("|")?.map((s: string) => s.trim()) || [];

      // rows.map((row: any, idx: number) => (row.key = idx)); // แบบเก่า
      rows = rows.map((row: any, idx: number) => {
        const shouldChangeId =
          tableGenerateNewGuid?.IsActive &&
          splitTemplateCode.includes(templateCode) &&
          splitTable.includes(matchedTableName);
        row.key = idx;

        if (shouldChangeId && idx === key + 1) {
          if (idx === key + 1) {
            row.id = generateQuickGuid();
          }
        }

        return row;
      });

      // if (rows.length > 0) {
      //   summaryFunc();
      // }

      onChange({ ...layout, data: { row: returnToValue(rows) } }, 0);
    } catch (error) {
      console.error("table=>error", error);
    }
    setTimeout(() => {
      setTableLoad(false);
    }, 500);
  };

  const moveTo = (key: number) => {
    try {
      if (moveFormIndex !== -1) {
        let dd = JSON.stringify(_data);
        let rows: any[] = JSON.parse(dd);
        let updateRow = rows.splice(moveFormIndex, 1)[0];
        rows.splice(key, 0, updateRow);
        setMoveFormIndex(-1);
        rows.map((row: any, idx: number) => (row.key = idx));

        onChange({ ...layout, data: { row: returnToValue(rows) } }, 0);

        setTimeout(() => {
          setTableLoad(false);
        }, 500);
      }
    } catch (error) {
      console.error("table=>error", error);
    }
  };
  // console.log(layout.template.disAllowAction);

  const actionBodyTemplate = (key: number) => {
    const cantEdit = (typeof layout.template.disAllowAction?.edit === "boolean") && layout.template.disAllowAction?.edit
    const cantCreate = cantEdit || (typeof layout.template.disAllowAction?.edit !== "boolean") && layout.template.disAllowAction?.edit?.create
    const cantMove = cantEdit || (typeof layout.template.disAllowAction?.edit !== "boolean") && layout.template.disAllowAction?.edit?.move
    const cantDuplicate = cantEdit || (typeof layout.template.disAllowAction?.edit !== "boolean") && layout.template.disAllowAction?.edit?.duplicate
    const cantDelete = cantEdit || (typeof layout.template.disAllowAction?.edit !== "boolean") && layout.template.disAllowAction?.edit?.delete
    const items = [
      {
        label: "Create new item",
        icon: "pi pi-fw pi-plus",
        items: [
          {
            label: "Create new item above",
            icon: "pi pi-fw pi-plus",
            command: () => {
              setTableLoad(true);
              addRowTo(key);
            },
          },
          {
            label: "Create new item below",
            icon: "pi pi-fw pi-plus",
            command: () => {
              setTableLoad(true);
              addRowTo(key + 1);
            },
          },
        ],
        disabled: cantCreate
      },
      {
        label: "Move to",
        icon: "pi pi-fw pi-sort-alt",
        command: () => {
          setMoveFormIndex(key);
          setMoveToDialogVisible(true);
        },
        disabled: cantMove
      },
      {
        label: "Duplicate",
        icon: "pi pi-fw pi-copy",
        command: () => {
          setTableLoad(true);
          duplicate(key);
        },
        disabled: cantDuplicate
      },
      {
        label: "Delete",
        icon: "pi pi-fw pi-trash",
        command: () => {
          setTableLoad(true);
          handleDelete(key);
        },
        disabled: cantDelete
      },
    ];
    return (
      <React.Fragment>
        <TieredMenu
          model={items}
          popup
          ref={(el) => {
            menu.current[key] = el;
          }}

        />
        <i className=" header-click">
          <IoEllipsisVertical className="pi pi-bars" />
        </i>
      </React.Fragment>
    );
  };

  const columns = defColumns.map((col: any) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record: any, rowIndex: number) => ({
        record,
        rowIndex: rowIndex,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
        template: layout.template,
        onControlChange,
        rowTemplate,
        colTemplate,
        canEditDoc,
        checkActionPage,
        buttonType,
        allLogicInTable,
        refDocOptions,
        refTableColumn,
        actionAlert,
        getValues,
        keytable, // Pass keytable to EditableCell
      }),
    };
  });

  const calCulateTableFooter = (changeObj?: any) => {
    try {
      const columns = layout.template.attribute.column;
      let decimal: number = 2;

      setTableFooter([
        ...tableFooter.map((footer: any) => {
          let formu = footer?.formula;

          let allField = formu.match(/[^+%\-\*\/=]+/g) || [];

          allField = allField.map((e: string) => {
            const newField = balanceParentheses(e);

            return newField;
          });

          if (changeObj && changeObj.label === footer.label) {
            footer.value = changeObj?.value;
          }
          columns?.forEach((col: any) => {
            if (allField.includes(col.label)) {
              decimal = Number(col.control.template.attribute.decimal);

              formu = formu?.replaceAll(
                col.label,
                summary[col.label]?.toFixed(decimal) !== "NaN"
                  ? summary[col.label]?.toFixed(decimal)
                  : Number(0).toFixed(decimal)
              );
            } else if (allField.includes("value")) {
              decimal = Number(col.control.template.attribute.decimal);

              formu = formu.replaceAll(
                "value",
                footer?.value?.toFixed(decimal)
              );
            }
          });
          const validate: any[] =
            formu.match(/[\u0E00-\u0E7FA-Za-z]+|\([^)]+\)+/g) || [];

          if (validate.length > 0) {
            tableFooter.map((e: any) => {
              if (formu.indexOf(e.label) !== -1) {
                formu = formu.replaceAll(
                  e.label,
                  Number(e?.result.replaceAll(",", ""))
                );
              }
            });
          }

          if (footer?.formula.includes("value")) {
            const value = eval(formu)?.toLocaleString(undefined, {
              maximumFractionDigits: 2,
            });

            footer.result = value;
          } else {
            const value = eval(formu)?.toLocaleString(undefined, {
              maximumFractionDigits: 2,
            });
            footer.result = value;
          }

          return footer;
        }),
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  async function fetchRefDocFormTable() {
    let tempAtt = layout.template.attribute;

    // if (!tempAtt.refdoc.docref.length) return setSpinloading(true)
    if (refDocOptions.length === 0) {
      setRefTableLoading(true);

      if (tempAtt !== undefined) {
        if (tempAtt.refdoc !== undefined) {
          let dataRequest = {
            PageIndex: 0,
            PageSize: 0,
            CUserID: memoDetail.creator.EmployeeId.toString(),
            RUserID: memoDetail.requestor.EmployeeId.toString(),
            ConditionRefdoc:
              tempAtt.conditionrefdoc.length > 0
                ? JSON.stringify(tempAtt.conditionrefdoc)
                : "",
            Search: memoDetail.creator.NameEn,
            docDataSource: tempAtt.refdoc.docDataSource,
            docReport: tempAtt.refdoc.docReport,
            docCancelDoc: tempAtt.refdoc.docCancelDoc,
            docEditDoc: tempAtt.refdoc.docEditDoc,
            docNewDoc: tempAtt.refdoc.docNewDoc,
            doccontrol: tempAtt.refdoc.doccontrol !== "N",
            docref: tempAtt.refdoc.docref,
          };
          const refDetails = await GetRefDocFormTable(dataRequest);

          if (tempAtt.refdoc.docDataSource === "Template") {
            let refColumn: any[] = [];
            let refOptions: any[] = [];
            refDetails?.forEach((e: any) => {
              let _option: any = { Memo_MemoId: e.MemoId };
              let advanceForm = JSON.parse(e.MAdvancveForm);
              advanceForm.items.map((a: any) => {
                a.layout.map((l: any) => {
                  const target = tempAtt.mergecolumnrefdoc.find(
                    (col: any) =>
                      col.RefDocLabel.split("_")[1] === l.template.label
                  );

                  if (target) {
                    _option[target.RefDocLabel] = l.data.value;
                    _option[l.template.label] = l.data.value;
                  }
                  tempAtt.mergecolumnrefdoc.map((a: any) => {
                    if (a.RefDocLabel === "DocumentNo") {
                      _option[a.RefDocLabel] = e.DocumentNo;
                      _option[a.RefDocLabel] = e.DocumentNo;
                    } else if (a.RefDocLabel === "DocumentAmount") {
                      _option[a.RefDocLabel] = e.Amount;
                      _option[a.RefDocLabel] = e.Amount;
                    } else if (a.RefDocLabel === "CreatorEmployeeCode") {
                      _option[a.RefDocLabel] = e.CreatorId;
                      _option[a.RefDocLabel] = e.CreatorId;
                    } else if (a.RefDocLabel === "CreatorEmployeeName") {
                      if (memoDetail.report_lang.toLowerCase() === "en") {
                        _option[a.RefDocLabel] = e.CNameEn;
                        _option[a.RefDocLabel] = e.CNameEn;
                      } else {
                        _option[a.RefDocLabel] = e.CNameTh;
                        _option[a.RefDocLabel] = e.CNameTh;
                      }
                    } else if (a.RefDocLabel === "CreatorEmployeePosition") {
                      _option[a.RefDocLabel] = e.CPositionEn;
                      _option[a.RefDocLabel] = e.CPositionEn;
                    } else if (a.RefDocLabel === "CreatorEmployeeDivision") {
                      _option[a.RefDocLabel] = e.CDivisionEn;
                      _option[a.RefDocLabel] = e.CDivisionEn;
                    } else if (a.RefDocLabel === "CreatorEmployeeDepartment") {
                      _option[a.RefDocLabel] = e.CDepartmentEn;
                      _option[a.RefDocLabel] = e.CDepartmentEn;
                    } else if (a.RefDocLabel === "CreatorEmployeeEmail") {
                      _option[a.RefDocLabel] = "";
                      _option[a.RefDocLabel] = "";
                    } else if (a.RefDocLabel === "RequestorEmployeeCode") {
                      _option[a.RefDocLabel] = e.RequesterId;
                      _option[a.RefDocLabel] = e.RequesterId;
                    } else if (a.RefDocLabel === "RequestorEmployeeName") {
                      if (memoDetail.report_lang.toLowerCase() === "en") {
                        _option[a.RefDocLabel] = e.RNameEn;
                        _option[a.RefDocLabel] = e.RNameEn;
                      } else {
                        _option[a.RefDocLabel] = e.RNameTh;
                        _option[a.RefDocLabel] = e.RNameTh;
                      }
                    } else if (a.RefDocLabel === "RequestorEmployeePosition") {
                      if (memoDetail.report_lang.toLowerCase() === "en") {
                        _option[a.RefDocLabel] = e.RPositionEn;
                        _option[a.RefDocLabel] = e.RPositionEn;
                      } else {
                        _option[a.RefDocLabel] = e.RPositionTh;
                        _option[a.RefDocLabel] = e.RPositionTh;
                      }
                    } else if (a.RefDocLabel === "RequestorEmployeeDivision") {
                      if (memoDetail.report_lang.toLowerCase() === "en") {
                        _option[a.RefDocLabel] = e.RDivisionEn;
                        _option[a.RefDocLabel] = e.RDivisionEn;
                      } else {
                        _option[a.RefDocLabel] = e.RDivisionTh;
                        _option[a.RefDocLabel] = e.RDivisionTh;
                      }
                    } else if (
                      a.RefDocLabel === "RequestorEmployeeDepartment"
                    ) {
                      if (memoDetail.report_lang.toLowerCase() === "en") {
                        _option[a.RefDocLabel] = e.RDepartmentEn;
                        _option[a.RefDocLabel] = e.RDepartmentEn;
                      } else {
                        _option[a.RefDocLabel] = e.RDepartmentTh;
                        _option[a.RefDocLabel] = e.RDepartmentTh;
                      }
                    } else if (a.RefDocLabel === "RequestorEmployeeEmail") {
                      _option[a.RefDocLabel] = "";
                      _option[a.RefDocLabel] = "";
                    } else if (a.RefDocLabel === "InformationDocumentStatus") {
                      _option[a.RefDocLabel] = e.StatusName;
                      _option[a.RefDocLabel] = e.StatusName;
                    } else if (a.RefDocLabel === "InformationFormName") {
                      _option[a.RefDocLabel] = e.TemplateName;
                      _option[a.RefDocLabel] = e.TemplateName;
                    } else if (a.RefDocLabel === "InformationRequestDate") {
                      _option[a.RefDocLabel] = e.RequestDate;
                      _option[a.RefDocLabel] = e.RequestDate;
                    } else if (a.RefDocLabel === "InformationCompany") {
                      _option[a.RefDocLabel] = e.CompanyName;
                      _option[a.RefDocLabel] = e.CompanyName;
                    } else if (a.RefDocLabel === "InformationBranch") {
                      _option[a.RefDocLabel] = e.DocumentNo;
                      _option[a.RefDocLabel] = e.DocumentNo;
                    } else if (a.RefDocLabel === "InformationSubject") {
                      _option[a.RefDocLabel] = e.MemoSubject;
                      _option[a.RefDocLabel] = e.MemoSubject;
                    } else if (a.RefDocLabel === "InformationProject") {
                      _option[a.RefDocLabel] = "";
                      _option[a.RefDocLabel] = "";
                    }
                  });
                });
              });
              refOptions.push(_option);
            });
            tempAtt.mergecolumnrefdoc?.forEach((e: any) => {
              refColumn.push({
                field: e.RefDocLabel,
                headerEn: e.RefDocLabel,
              });
            });

            setSpinloading(true);
            setRefDocOptions([...refOptions]);
            setRefTableColumn([...refColumn]);
          } else if (tempAtt.refdoc.docDataSource === "Report") {
            dataRequest.docref = refDetails?.TemplateId?.split("|").map(
              (e: string) => {
                return { id: e };
              }
            );
            const refReportDetail = await GetRefDocFormTable(dataRequest);

            if (refReportDetail?.dt_Report?.length > 0) {
              let refColumn: any[] = [];

              tempAtt?.mergecolumnrefdoc?.forEach((e: any) => {
                refColumn.push({
                  field: e.RefDocLabel,
                  headerEn: e.RefDocLabel,
                });
              });

              setSpinloading(true);
              setRefTableColumn([...refColumn]);
              setRefDocOptions([...refReportDetail.dt_Report]);
            }
          } else {
            setSpinloading(true);
          }
        }
      } else {
        setSpinloading(true);
      }
    } else {
      setSpinloading(true);
    }

    setRefTableLoading(false);
  }
  const onImportExcel = async (dataJson: any) => {
    const response = await fetch("api/Excel/ImportData", {
      method: "POST",
      body: dataJson,
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    if (response) {
      const checkedDD: any = {};
      let findedItems: any = {};
      columns.find((col: any) => {
        if (col?.template?.attribute?.items?.length > 1) {
          checkedDD[col.dataIndex] = [];
          findedItems[col.dataIndex] = col.template.attribute.items.map(
            (e: { item: any }) => e.item
          );
        }
      });
      if (Object.keys(checkedDD).length === 0) return response;

      const dataKeys = Object.keys(response[0]);
      dataKeys.forEach((key: string) => {
        if (!findedItems[key]) return;
        response.forEach((item: any, idx: number) => {
          !findedItems[key]?.includes(item[key]) &&
            !checkedDD[key].includes(item[key]) &&
            checkedDD[key].push(item[key]);
        });
      });
      const checkedErr = Object.entries(checkedDD).some(([key, value]: any) => {
        if (value.length > 0) {
          toggleAlert({
            type: "error",
            message: "Validate",
            description: `ไม่มีค่า '${value.join(", ")}' ใน ${key} `,
            duration: 5,
          });
        }
        return value.length > 0;
      });
      if (checkedErr) return null;
    }
    return response;
  };

  const onExportExcel = async (dataJson: any) => {
    try {
      const fileName = "export.xlsx";
      const response = await fetch("api/Excel/ExportData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Ensure correct content type
        },
        body: JSON.stringify({
          mAdvance: JSON.stringify(dataJson),
        }),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((error) => console.error("Download failed:", error));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFileUpload = async (file: any) => {
    try {
      const uploadFile = new FormData();
      uploadFile.append("file", file);
      const respone = await onImportExcel(uploadFile);
      if (respone) {
        putExcelToTable(respone);
        setExportFile(respone);
      }
    } catch (error: any) {
      console.error(error.message);
    }
  };

  const putExcelToTable = (resultData: any[]) => {
    const result = resultData.slice(0, resultData.length);

    let newRows = resultData.slice(0, resultData.length);
    confirm({
      title: "Preview data",
      icon: "",
      className: "csv-confirm-modal",
      content: (
        <ExcelTablePreview
          newRows={result}
          columns={columns}
          onCheckedHeader={(e) => {
            if (e) {
              newRows = result.slice(1, newRows.length);
            } else {
              newRows = result;
            }
          }}
        />
      ),
      width: "80%",
      okButtonProps: {
        icon: <CheckCircleOutlined rev={undefined} />,
        className: "confirm-btn ok",
        style: { display: "flex", alignItems: "center" },
      },
      onOk() {
        let tableSums: any = {};

        onChange({
          ...layout,
          data: {
            row: calCulateInTableFunc(
              { ...layout, data: { row: returnToValue(newRows) } }, 0
            ),
          },
        });
      },
      cancelButtonProps: {
        icon: <CloseSquareOutlined rev={undefined} />,
        type: "ghost",
        className: "cancel",
        style: { display: "flex", alignItems: "center" },
      },
    });
  };

  const menuClickHandler = (key: string) => {
    if (key === "import") {
      // Trigger file input click when Import is clicked
      const input = document.createElement("input");
      input.type = "file";
      input.accept = ".xlsx";
      input.onchange = (e: any) => {
        const file = e?.target?.files[0];
        if (file) {
          handleFileUpload(file);
        }
      };
      input.click();
    } else if (key === "export") {
      layout.data = { row: returnToValue(_data) };
      onExportExcel(layout);
    }
  };
  const menuItem = (
    <Menu
      onClick={(info) => {
        menuClickHandler(info.key);
      }}
    >
      <Menu.Item key="import" icon={<FileTextOutlined rev={undefined} />}>
        <div>Import</div>
      </Menu.Item>

      <Menu.Item key="export" icon={<FileTextOutlined rev={undefined} />}>
        <a>Export</a>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div style={{ display: "flex", marginBottom: 10 }}>
        <ComponentLabel
          colText={12}
          rowIdx={rowIdx}
          colIdx={rowIdx}
          template={layout.template}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          rightComponent={
            layout.template.canImport === "Y" && (
              <Dropdown overlay={menuItem}>
                <Button
                  label="Import/Export"
                  icon="pi pi-book"
                  type={"button"}
                  loading={loadFile}
                  onClick={(e) => e.preventDefault()}
                  style={{
                    height: "38px",
                    color: "#ffffff",
                    fontSize: "1em",
                    borderRadius: "6px",
                    margin: " 11px 11px 0px 0px",
                    justifyContent: "center",
                  }}
                />
              </Dropdown>
            )
          }
        />
      </div>
      <Col
        sm={12}
        md={12}
        xs={12}
        xl={12}
        className={"padding-controller"}
        // onClick={() => {
        //   if (tableLoad) {
        //     setTableLoad(false);
        //   }
        // }}
      >
        <Spin spinning={!spinloading} tip="Loading...">
          <Table
            className={`padding - controller control - table ${isError && "error-table"
              } `}
            components={{
              body: {
                cell: EditableCell,
                row: EditableRow,
              },
            }}
            
            dataSource={_data}
            loading={{
              spinning: tableLoad,
              indicator: (
                <div style={{ transform: 'translate(-50%, -50%)', position: 'absolute', top: '50%', left: '50%', width: '300px' }}>
                  <Progress 
                    percent={percent} 
                    status={percent === 100 ? "success" : "active"} 
                    strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
                  />
                  <div style={{ marginTop: 8, color: '#1890ff', fontWeight: 'bold', textAlign: 'center' }}>
                    {percent < 95 ? "Loading..." : "Processing..."}
                  </div>
                </div>
              )
            }}
            columns={columns as ColumnTypes}
            rowClassName={() => "editable-row"}
            bordered
            id="table-control"
            scroll={{ x: 1500 - 1000, y: 500 }}
              onChange={(pagination, filters, sorter, extra) => {
      // เก็บค่า row ที่เหลือหลัง filter ลง state filteredRows\
            
          if(extra.currentDataSource?.length === _data.length){
          setFilteredRows(null);
          }else{
          setFilteredRows(extra.currentDataSource  || []);

          }

          if(extra.action === "sort" || extra.action === "filter"){
            setCurrentDataSource(extra.currentDataSource || null);
          }
          console.log(extra ,sorter,"currentDataSource");
                }}
            footer={() => {
              const haveInput = tableFooter?.find((e: any) => e.useValue);

              return tableFooter.map((footer: any) => {
                return (
                  <TableFooter
                    footerAtt={footer}
                    onChange={calCulateTableFooter}
                    haveInput={haveInput !== undefined}
                  />
                );
              });
            }}
            summary={() => {
              try {
                const cols = layout?.template?.attribute?.column;
                let isShowSum = false;
                cols?.forEach((col: any) => {
                  if (col.control.template.attribute.isSummary === "Y") {
                    isShowSum = true;
                    return;
                  }
                });
                if (isShowSum && _data.length > 0 && summary) {
                  return (
                    <Table.Summary fixed>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}>
                          <span>Total</span>
                        </Table.Summary.Cell>
                        {cols.map((col: any, idx: any) => {
                          if (
                            col.control.template.attribute.isSummary !== "Y"
                          ) {
                            return (
                              <Table.Summary.Cell
                                index={idx}
                              ></Table.Summary.Cell>
                            );
                          } else {
                            return (
                              <Table.Summary.Cell index={idx} align="right">
                                <Text style={{ margin: "15px" }}>
                                  {!isNaN(
                                    Number(summary[col.control.template.label])
                                  )
                                    ? Number(
                                      Number(
                                        summary[col.control.template.label]
                                      )
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: Number(
                                        col.control.template.attribute.decimal
                                      ),
                                    })
                                    : "0.00"}
                                </Text>
                              </Table.Summary.Cell>
                            );
                          }
                        })}
                        <Table.Summary.Cell
                          index={cols.length + 1}
                        ></Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  );
                }
              } catch (error) {
                if (process.env.NODE_ENV === "development") {
                  console.error("table=>sum=>", error);
                }
              }
            }}
          />
        </Spin>
        <MoveToDialog
          header={"Move To"}
          dataLength={_data.length}
          isVisible={moveToDialogVisible}
          setIsVisible={setMoveToDialogVisible}
          setLoading={setTableLoad}
          moveFunc={moveTo}
        />
        <SelectDataDialog
          dialogKey={"Memo_Memo"}
          dataList={refDocOptions}
          dialogVisible={refTableDialogVisible}
          setDialogVisible={setRefTableDialogVisible}
          columns={refTableColumn}
          loading={refTableLoading}
          selectionMode="multi"
          mutiable
          onSelectFunc={async (_selectedData) => {
            try {
              if (_selectedData?.length > 0) {
                const newRows = await Promise.all(
                  _selectedData.map(async (e: any, idx: number) => {
                    let newRow = await createRowCopy(idx);

                    if (newRow["rowstate"] !== undefined) {
                      newRow["rowstate"] = "i";
                    }
                    // layout.template?.attribute?.column?.forEach((item: any) => {
                    //   const key = item.label;
                    //   layout.template?.attribute?.mergecolumnrefdoc?.forEach((col: any) => {
                    //     if (key === col.ColumnLabel) {
                    //       newRow[key] = e[col.RefDocLabel];
                    //       newRow['memoRef'] = e;
                    //     }
                    //   });
                    //   if (newRow[key] === undefined) {
                    //     newRow[key] = item.control?.template?.attribute?.default ?? null;
                    //   }
                    // });


                    layout.template?.attribute?.mergecolumnrefdoc?.forEach(
                        (col: any) => {
                          newRow[col.ColumnLabel] = e[col.RefDocLabel || col.ColumnLabel];
                          newRow['memoRef'] = e
                        }
                      );

                    return newRow;
                  })
                );

                handleAddMultiRow(newRows);

                // setSelectedData([]);
                setRefTableDialogVisible(false);
              }
            } catch (error) {
              if (process.env.NODE_ENV === "development") {
                console.error("table=>ref=>", error);
              }
            }
          }}
        />
      </Col>
    </>
  );
};

export default React.memo(TableComponent);
